import { createSelector } from '@reduxjs/toolkit';
// Derived selectors
export const selectUserData = createSelector(
  state => state.users,
  (users) => ({
    userData: users.userData,
    loading: users.loading
  })
);

export const selectNotificationData = createSelector(
  state => state.notifications,
  (notifications) => ({
    notificationData: notifications.notificationData,
    loading: notifications.loading
  })
);
